const getValidViewMode = (value, viewModes, fallback) => {
  const mode = Array.isArray(value) ? value[0] : value;
  return viewModes?.[mode] ? mode : fallback;
};

export default getValidViewMode;
